import styled from "styled-components";
import { Flex } from "antd";

const StyledContainer = styled(Flex)`
  .ant-input-number {
    width: 65px;

    .ant-input-number-input {
      padding: 4px 8px;
    }
  }
`;

export default StyledContainer;
